/** Read-only window (SA-1136; spec §6.3): the range and flexibility with the customer's words in a Tip, a dotted chip when guessed. */
import { Badge, Tip } from '@/components/ui'
import { windowState, type WindowSlotValue } from '@/components/records/window'
import { GUESSED, windowLine } from '@/components/records/windowText'

export function WindowValue({ value }: { value: WindowSlotValue }) {
  const guessed = windowState(value) === 'guessed'
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <Tip text={value.text}><span tabIndex={0}>{windowLine(value)}</span></Tip>
      {guessed && <Badge variant="muted-soft" dot="bg-muted-foreground">{GUESSED}</Badge>}
    </span>
  )
}
